"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var icons = {
  Dashboard: 'home',
  "Tableau de bord": 'home',
  Notifications: 'notifications',
  Settings: 'settings',
  Paramètres: 'settings',
  'My Account': 'person',
  'Mon compte': 'person',
  Resources: 'import_contacts',
  Claims: 'list',
  Réclamations: 'list',
  'Usage': 'bar_chart',
  "Mon utilisation": 'bar_chart',
  'My Usage': 'bar_chart',
  'Spending Accounts': 'attach_money',
  "Comptes de dépenses": 'attach_money',
  Coverage: 'list_alt',
  Couverture: 'list_alt',
  'Benefits Card': 'payment',
  "Carte D'avantages": 'payment',
  'Support': 'contact_support',
  'Optional Benefits': 'shopping_cart',
  Marketplace: 'shopping_cart',
  Plan: 'list_alt',
  Employees: 'people',
  Employés: 'people',
  Reports: 'timeline',
  Rapports: 'timeline',
  Invoices: 'attach_money',
  Factures: 'attach_money',
  Administrators: 'admin_panel_settings',
  Administrateurs: 'admin_panel_settings',
  Quotes: 'request_quote',
  Soumissions: 'request_quote',
  'Active Accounts': 'done_all',
  "Comptes Actifs": 'done_all',
  'Pending Accounts': 'alarm_on',
  "Comptes en Attente": 'alarm_on',
  'Lost Opportunities': 'thumb_down',
  "Opportunités Perdues": 'thumb_down',
  Commissions: 'monetization_on',
  'Under Revisions': 'build',
  'Under Amendment': 'build',
  "En Modification": 'build',
  'Classes & Divisions': 'switch_account',
  'Account History': 'history',
  Census: 'people',
  "Recensement": 'people',
  'Rate History': 'attach_money',
  "Historique des taux": 'attach_money',
  'Claims History': 'list_alt',
  "Historique des réclamations": 'list_alt',
  'Past Bill': 'history',
  "Facture passée": 'history',
  'Supporting Documents': 'cloud_upload',
  "Documents à l'appui": 'cloud_upload',
  'Plan Designs': 'list_alt',
  'Master Application': 'assignment',
  "Application Principale": 'assignment',
  'Send For Underwriting': 'security',
  'Create Admin': 'add',
  "Créer un administrateur": 'add',
  "Plan Sponsor": 'local_police',
  "Parent Admin": "admin_panel_settings",
  'Plan Overview': 'list_alt',
  "Aperçu du plan.": 'list_alt',
  Pricing: 'local_offer',
  "Tarification": 'local_offer',
  'Plan Pricing': 'local_offer',
  'Account Details': 'settings',
  'Détails du compte': 'settings',
  Adjudication: 'verified_user',
  'Create Claim': 'add',
  Advisors: 'supervisor_account',
  Accounts: 'manage_accounts',
  Emails: 'email',
  'Review Rates': 'bar_chart',
  'Start Revisions': 'build',
  'Members': 'account_circle',
  'Quotes for Review': 'assignment_turned_in',
  'Data Uploads': 'cloud_upload',
  'Data Downloads': 'cloud_download',
  'Download': 'download',
  'Admin Reports': 'security',
  'Accounting Reports': 'account_balance',
  'Business Insight Reports': 'business',
  'Person': 'person',
  'Uploads': 'cloud_upload',
  'Profile': 'person',
  'Dependents': 'supervisor_account',
  "Personnes à charge": 'supervisor_account',
  'Beneficiaries': 'supervised_user_circle',
  'Bénéficiaires': 'supervised_user_circle',
  'Trustee': 'add_moderator',
  'Fiduciaire': 'add_moderator',
  'Member Booklets': 'menu_book',
  'ASO Reporting': 'signal_cellular_alt',
  'Change Password': 'security',
  'Changer le mot de passe': 'security',
  'Banking Details': 'account_balance',
  'Détails bancaires': 'account_balance',
  'Employee Booklet': 'menu_book',
  'Allow Enrollments': 'mail',
  'Renewals': 'autorenew',
  'Filter': 'filter_list',
  'Bird': 'flutter_dash',
  'Metrics': 'bar_chart',
  'Amendments': 'edit',
  'Amendements': 'edit',
  'Pending Changes': 'access_time',
  'LSA Categories': 'category',
  "Catégories de dépenses liées au mode de vie": 'category',
  'Close': 'close',
  'Coverage History': 'history',
  'Underwriting Reports': 'edit_note',
  'Terminate Account': 'delete_forever',
  'Marketplace Reports': 'shopping_cart',
  'Account Notes': 'format_list_bulleted',
  'Carry Forward': 'turn_right',
  'Redirect': 'launch',
  "Dental Data": "find_in_page"
};
var _default = exports["default"] = icons;